var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 11.5487V8.76872C23 7.11872 21.65 5.76872 20 5.76872H16C15.23 5.76872 14.53 6.06872 14 6.54872C13.47 6.06872 12.77 5.76872 12 5.76872H8C6.35 5.76872 5 7.11872 5 8.76872V11.5487C4.39 12.0987 4 12.8887 4 13.7687V19.7687H6V17.7687H22V19.7687H24V13.7687C24 12.8887 23.61 12.0987 23 11.5487ZM16 7.76872H20C20.55 7.76872 21 8.21872 21 8.76872V10.7687H15V8.76872C15 8.21872 15.45 7.76872 16 7.76872ZM7 8.76872C7 8.21872 7.45 7.76872 8 7.76872H12C12.55 7.76872 13 8.21872 13 8.76872V10.7687H7V8.76872ZM6 15.7687V13.7687C6 13.2187 6.45 12.7687 7 12.7687H21C21.55 12.7687 22 13.2187 22 13.7687V15.7687H6Z",
    fill: "#D5B480"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBed);
export default __webpack_public_path__ + "static/media/bed.67c8398f7b88ed312bc73de2fe1e86fb.svg";
export { ForwardRef as ReactComponent };